import {LitElement, html, css, nothing} from 'lit';

export class ProjectTagElement extends LitElement {
    static get styles() {
        return css`
        :host {
            display: flex;
            padding:0;
            margin:0;
            color: #959595;
            position: relative;
            margin-right: 0.8em;
            margin-bottom: 0.8em;
        }
        .tag-element {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            padding-left: 0.8em;
            background-color: #333;
            border: 2px dashed #444;
            border-radius: 3px;
            font-weight: bold;
            cursor: pointer;
            text-decoration: none;
        }
        .tag-element--verified {
            border-style: solid;
        }
        .tag-element--universe {
            background-color: #1e3416;
        }
        .tag-element--character {
            background-color: #17334a;
        }
        .tag-element--software {
            background-color: #350606;
        }
        .tag-element--misc {
            background-color: #333;
        }
        .tag-element-type {
            margin-right: 0.3em;
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: 100%;
        }
        .tag-element-name {
            color: #FFF;
            margin-right: 0.3em;
        }
        .tag-element-count {
            margin-right: 0.3em;
        }
        .tag-element-optionbutton {
            color: #aaa;
            padding-top: 0.5em;
            padding-right: 0.5em;
            padding-bottom: 0.5em;
        }
        .tag-element-optionbutton:hover {
            color: #FFF;
        }
        .tag-element-type svg {
            width: 16px;
            height: 16px;
        }
        .tag-element-options {
            list-style: none;
            position: absolute;
            left: 0;
            top: 1.85em;
            background-color: #333;
            z-index: 2;
            padding: 0;
            border: 1px solid #444;
            border-radius: 3px;
        }
        .tag-element-option {
            display: flex;
            flex-direction: row;
            margin-left: 0;
            min-width: 300px;
            box-shadow: 0 0 0 1px #333;
            padding: 0.5em;
        }
        .tag-element-option:hover {
            color: #FFF;
            background-color: #444;
            cursor: pointer;
        }
        .tag-element-option:first-child {
            border-top-left-radius: 3px;
            border-top-right-radius: 3px;
        }
        .tag-element-option:last-child {
            border-bottom-left-radius: 3px;
            border-bottom-right-radius: 3px;
        }
        .tag-element-option svg {
            width: 20px;
            height: 20px;
            fill: #959595;
            margin-right: 0.5em;
        }
        `;
    }
    
    static get properties() {
        return {
            id: { type: Number },
            projectid: { type: Number },
            name: { type: String },
            type: { type: String },
            count: { type: Number },
            votes: { type: Number },
            aigenerated: { type: Boolean,
                converter: {
                    fromAttribute: (value, type) => {

                        console.log('aigenerated', value);
                        if (value === 'true' || value === 'True' || value == '1' || value === true) {
                            return true;
                        }
                        return false;
                    },
                    toAttribute: (value, type) => {
                        if (value === true) {
                            return 'true';
                        }
                    }
                }
            },
            approved: { type: Boolean,
                converter: {
                    fromAttribute: (value, type) => {
                    if (value === 'true' || value === 'True' || value == '1' || value === true) {
                        return true;
                    }
                    return false;
                    }
                }
            },
            expanded: { type: Boolean },
            adminoptions: {
                type: Boolean,
                converter: {
                    fromAttribute: (value, type) => {
                    if (value === 'true' || value === 'True' || value == '1' || value === true) {
                        return true;
                    }
                    return false;
                    }
                }
            },

        };
    }

    constructor() {
        super();
        this.id = 0;
        this.projectid = 0;
        this.name = '';
        this.type = '';
        this.count = 0;
        this.votes = 0;
        this.approved = false;
        this.expanded = false;
        this.aigenerated = false;
        this.adminoptions = false;
    }

    getIcon() {
        if (this.aigenerated) {
            return html`<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="ai-gen" class="svg-inline--fa fa-ai-gen fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path fill="gold" d="M464 6.1c9.5-8.5 24-8.1 33 .9l8 8c9 9 9.4 23.5 .9 33l-85.8 95.9c-2.6 2.9-4.1 6.7-4.1 10.7l0 21.4c0 8.8-7.2 16-16 16l-15.8 0c-4.6 0-8.9 1.9-11.9 5.3L100.7 500.9C94.3 508 85.3 512 75.8 512c-8.8 0-17.3-3.5-23.5-9.8L9.7 459.7C3.5 453.4 0 445 0 436.2c0-9.5 4-18.5 11.1-24.8l111.6-99.8c3.4-3 5.3-7.4 5.3-11.9l0-27.6c0-8.8 7.2-16 16-16l34.6 0c3.9 0 7.7-1.5 10.7-4.1L464 6.1zM432 288c3.6 0 6.7 2.4 7.7 5.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8-14.8 51.7c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8l-14.8-51.7-51.7-14.8c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8 14.8-51.7c1-3.4 4.1-5.8 7.7-5.8zM87.7 69.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8L87.7 218.2c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8L57.5 166.5 5.8 151.7c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8L72.3 69.8c1-3.4 4.1-5.8 7.7-5.8s6.7 2.4 7.7 5.8zM208 0c3.7 0 6.9 2.5 7.8 6.1l6.8 27.3 27.3 6.8c3.6 .9 6.1 4.1 6.1 7.8s-2.5 6.9-6.1 7.8l-27.3 6.8-6.8 27.3c-.9 3.6-4.1 6.1-7.8 6.1s-6.9-2.5-7.8-6.1l-6.8-27.3-27.3-6.8c-3.6-.9-6.1-4.1-6.1-7.8s2.5-6.9 6.1-7.8l27.3-6.8 6.8-27.3c.9-3.6 4.1-6.1 7.8-6.1z"/>
            </svg>`;
        }

        if (this.type === 'universe') {
            return html`
                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="globe-europe" class="svg-inline--fa fa-globe-europe fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512">
                    <path fill="#959595" d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm200 248c0 22.5-3.9 44.2-10.8 64.4h-20.3c-4.3 0-8.4-1.7-11.4-4.8l-32-32.6c-4.5-4.6-4.5-12.1.1-16.7l12.5-12.5v-8.7c0-3-1.2-5.9-3.3-8l-9.4-9.4c-2.1-2.1-5-3.3-8-3.3h-16c-6.2 0-11.3-5.1-11.3-11.3 0-3 1.2-5.9 3.3-8l9.4-9.4c2.1-2.1 5-3.3 8-3.3h32c6.2 0 11.3-5.1 11.3-11.3v-9.4c0-6.2-5.1-11.3-11.3-11.3h-36.7c-8.8 0-16 7.2-16 16v4.5c0 6.9-4.4 13-10.9 15.2l-31.6 10.5c-3.3 1.1-5.5 4.1-5.5 7.6v2.2c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8s-3.6-8-8-8H247c-3 0-5.8 1.7-7.2 4.4l-9.4 18.7c-2.7 5.4-8.2 8.8-14.3 8.8H194c-8.8 0-16-7.2-16-16V199c0-4.2 1.7-8.3 4.7-11.3l20.1-20.1c4.6-4.6 7.2-10.9 7.2-17.5 0-3.4 2.2-6.5 5.5-7.6l40-13.3c1.7-.6 3.2-1.5 4.4-2.7l26.8-26.8c2.1-2.1 3.3-5 3.3-8 0-6.2-5.1-11.3-11.3-11.3H258l-16 16v8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-20c0-2.5 1.2-4.9 3.2-6.4l28.9-21.7c1.9-.1 3.8-.3 5.7-.3C358.3 56 448 145.7 448 256zM130.1 149.1c0-3 1.2-5.9 3.3-8l25.4-25.4c2.1-2.1 5-3.3 8-3.3 6.2 0 11.3 5.1 11.3 11.3v16c0 3-1.2 5.9-3.3 8l-9.4 9.4c-2.1 2.1-5 3.3-8 3.3h-16c-6.2 0-11.3-5.1-11.3-11.3zm128 306.4v-7.1c0-8.8-7.2-16-16-16h-20.2c-10.8 0-26.7-5.3-35.4-11.8l-22.2-16.7c-11.5-8.6-18.2-22.1-18.2-36.4v-23.9c0-16 8.4-30.8 22.1-39l42.9-25.7c7.1-4.2 15.2-6.5 23.4-6.5h31.2c10.9 0 21.4 3.9 29.6 10.9l43.2 37.1h18.3c8.5 0 16.6 3.4 22.6 9.4l17.3 17.3c3.4 3.4 8.1 5.3 12.9 5.3H423c-32.4 58.9-93.8 99.5-164.9 103.1z"></path>
                </svg>
            `;
        }
        if (this.type === 'character') {
            return html`
                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="female" class="svg-inline--fa fa-female fa-w-8" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
                    <path fill="#959595" d="M128 0c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64S92.654 0 128 0m119.283 354.179l-48-192A24 24 0 0 0 176 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H80a24 24 0 0 0-23.283 18.179l-48 192C4.935 369.305 16.383 384 32 384h56v104c0 13.255 10.745 24 24 24h32c13.255 0 24-10.745 24-24V384h56c15.591 0 27.071-14.671 23.283-29.821z"></path>
                </svg>
            `;
        }
        if (this.type === 'software') {
            return html`
                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="cube" class="svg-inline--fa fa-cube fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path fill="#959595" d="M239.1 6.3l-208 78c-18.7 7-31.1 25-31.1 45v225.1c0 18.2 10.3 34.8 26.5 42.9l208 104c13.5 6.8 29.4 6.8 42.9 0l208-104c16.3-8.1 26.5-24.8 26.5-42.9V129.3c0-20-12.4-37.9-31.1-44.9l-208-78C262 2.2 250 2.2 239.1 6.3zM256 68.4l192 72v1.1l-192 78-192-78v-1.1l192-72zm32 356V275.5l160-65v133.9l-160 80z"></path>
                </svg>
            `;
        }
        if (this.type === 'misc') {
            return html`
                <svg  aria-hidden="true" focusable="false" data-prefix="fas" data-icon="tag" class="svg-inline--fa fa-tag fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path fill="#959595" d="M48 32H197.5C214.5 32 230.7 38.74 242.7 50.75L418.7 226.7C443.7 251.7 443.7 292.3 418.7 317.3L285.3 450.7C260.3 475.7 219.7 475.7 194.7 450.7L18.75 274.7C6.743 262.7 0 246.5 0 229.5V80C0 53.49 21.49 32 48 32L48 32zM112 176C129.7 176 144 161.7 144 144C144 126.3 129.7 112 112 112C94.33 112 80 126.3 80 144C80 161.7 94.33 176 112 176z"/>
                </svg>
            `;
        }
    }

    _clickOptions(e) {
        e.preventDefault();
        this.expanded = !this.expanded;
    }

    _tagSearchClick(e) {
        e.preventDefault();
        window.location.href = this._tagUrl();
    }

    _upvoteTag(e) {
        e.preventDefault();
        this.removeFocus(e);
    }

    _downvoteTag(e) {
        e.preventDefault();
        this.removeFocus(e);
    }

    _approveTag(e) {
        e.preventDefault();

        let typestring = '';
        if (this.type === 'universe') {
            typestring = 'property';
        }
        if (this.type === 'character') {
            typestring = 'character';
        }
        if (this.type === 'software') {
            typestring = 'software';
        }
        if (this.type === 'misc') {
            typestring = 'misc';
        }

        var projectUrl = '/api/tag/' + typestring + '/item/approve/' + this.name + '/';

        var myInit = {
            method: 'GET'
        };

        var myRequest = new Request(projectUrl, myInit);

        fetch(myRequest).then(
            console.log('tag approved')
        ).catch(function (e) {
            console.log(e);
        });
        
        this.removeFocus(e);
        this.approved = !this.approved;
    }

    _removeTag(e) {
        e.preventDefault();
        console.log('remove tag');
        
        let typestring = '';
        if (this.type === 'universe') {
            typestring = 'property';
        }
        if (this.type === 'character') {
            typestring = 'character';
        }
        if (this.type === 'software') {
            typestring = 'software';
        }
        if (this.type === 'misc') {
            typestring = 'misc';
        }
        var projectUrl = '/api/tag/' + typestring + '/item/remove/' + this.projectid + '/' + this.name + '/';

        var myInit = {
            method: 'GET'
        };

        var myRequest = new Request(projectUrl, myInit);

        fetch(myRequest).then(
            console.log('tag removed')
        ).catch(function (e) {
            console.log(e);
        });
        
        this.removeFocus(e);
        this.parentElement.removeChild(this);
    }

    _tagUrl() {
        return `/?query=${this.name}`;

        if (this.type === 'universe') {
            return `/?universe_tag=${this.id}`;
        }
        if (this.type === 'character') {
            return `/?character_tag=${this.id}`;
        }
        if (this.type === 'software') {
            return `/?software_tag=${this.id}`;
        }
        if (this.type === 'misc') {
            return `/?general_tag=${this.id}`;
        }

    }

    renderOptionsList() {
        if (this.expanded) {
            return html`
                <ul class="tag-element-options">
                    <li class="tag-element-option" @click="${this._tagSearchClick}">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M500.3 443.7l-119.7-119.7c27.22-40.41 40.65-90.9 33.46-144.7C401.8 87.79 326.8 13.32 235.2 1.723C99.01-15.51-15.51 99.01 1.724 235.2c11.6 91.64 86.08 166.7 177.6 178.9c53.8 7.189 104.3-6.236 144.7-33.46l119.7 119.7c15.62 15.62 40.95 15.62 56.57 0C515.9 484.7 515.9 459.3 500.3 443.7zM79.1 208c0-70.58 57.42-128 128-128s128 57.42 128 128c0 70.58-57.42 128-128 128S79.1 278.6 79.1 208z"/></svg>
                        Search with this tag
                    </li>
                    ${this.adminoptions ? html`<li class="tag-element-option" @click="${this._removeTag}">🗑 Delete tag</li>` : nothing}
                    ${this.adminoptions ? html`<li class="tag-element-option" @click="${this._approveTag}">✔️ Approve tag</li>` : nothing}
                    <li class="tag-element-option" @click="${this._clickMore}">More options soon...</li>
                </ul>
            `;
        }
    }
    _clickMore(e) {
        e.preventDefault();
        this.expanded = !this.expanded;
        window.location.href = `https://www.patreon.com/sfmlab`;
    }

    render() {
        return html`
            <a href="${this._tagUrl()}" class="tag-element tag-element--${this.type} ${this.approved ? 'tag-element--verified' : ``}" @click="${this._clickOptions}">
                <span class="tag-element-type">${this.getIcon()}</span>
                <span class="tag-element-name">${this.name}</span>
                <span class="tag-element-optionbutton">...</span>
            </a>
            ${this.renderOptionsList()}
        `;
    }
    
    removeFocus(e) {
        if (!this.expanded) {
            return;
        }

        if (e.target != this) {
            this.expanded = false;
            return;
        }
    }

    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('click', this.removeFocus.bind(this));
    }
    disconnectedCallback() {
        window.removeEventListener('click', this.removeFocus.bind(this));
        super.disconnectedCallback();
    }
}

window.customElements.define('project-tag-element', ProjectTagElement);